// extracted by mini-css-extract-plugin
export default {"editor":"editor_editor__ZHKTr","multilineEditor":"editor_multilineEditor__-sAZW"};